<template>
  <el-dialog
    :visible.sync="detail.dialog"
    top="5vh"
    custom-class="dailogCustomerBase"
    width="80%">
    <template slot="title">
        <h1 style="margin:unset;text-align:left;">แก้ไขข้อมูลผู้ใช้งาน</h1>
    </template>
    <el-tabs tab-position="left" v-model="activeName">
        <el-tab-pane v-for="item in MenuList" :key="item.id" :label="item.name" :name="String(item.id)" ></el-tab-pane>
        <!-- <keep-alive> -->
            <component
                :is="currentTabComponent"
                :detail.sync="detail"
                :geoHierarchyData="geoHierarchyData"
                :provinceArray="provinceArray"
                :log.sync="log"
                :courierInfo.sync="courierInfo"
                :loadingTable.sync="loadingTable"
                :customerType="customerType"
                :btnSubscriptionPlan="btnSubscriptionPlan"
                :isSubmitForm="isSubmitForm"
                :isCancel="isCancel"
                @onCancel="(value)=>isCancel = value"
                ref="dialogCustomerBase"
            ></component>
        <!-- </keep-alive> -->
    </el-tabs>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button @click="onCancel">ยกเลิก</el-button>
      <el-button type="primary"  @click="submitEditUser()" >ยืนยัน</el-button>
    </span>
  </el-dialog>
</template>
<script>
import ModalCustomerDetail from '@/components/Customer/ModalCustomerDetail'
import CustomerAddressInfor from '@/components/Customer/CustomerAddress/CustomerAddressInfor'
import BookingDelivery from '@/components/Booking/BookingDelivery.vue'
import CustomerCourier from '@/components/Customer/CustomerCourier.vue'
import BaseSubscriptionForm from '@/components/Customer/Subscription/BaseSubscriptionForm'

import fgApi from '@/services/fillgoods'

export default {
    name: 'dialogCustomerBase',
    components: {
        ModalCustomerDetail,
        CustomerAddressInfor,
        BookingDelivery,
        CustomerCourier,
        BaseSubscriptionForm
    },
    props: {
        detail: {
            type: Object
        },
        provinceArray: {
            type: Array,
            default: null
        },
        geoHierarchyData: {
            type: Object,
            default: null
        },
        seller: {
            type: Array
        },
        customerType: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            activeName: '0',
            isSubmitForm: false,
            isCancel: false,
            MenuList: [
                { id: 0, name: 'ข้อมูลผู้เข้าใช้งาน', componentName: 'ModalCustomerDetail' },
                { id: 1, name: 'จัดการที่อยู่เข้ารับ', componentName: 'CustomerAddressInfor' },
                { id: 2, name: 'จัดการการจัดส่ง', componentName: 'BookingDelivery' },
                { id: 3, name: 'Courier', componentName: 'CustomerCourier' },
                { id: 4, name: 'Subscription', componentName: 'BaseSubscriptionForm' }
            ],
            log: {
                type: 'User',
                user_id: null,
                shop_id: null,
                editor_email: null,
                editor_value: null,
                payload: {
                    lhs: {
                        detail: {},
                        courier: {}
                    },
                    rhs: {
                        detail: {},
                        courier: {}
                    }
                },
                timestamp: null
            },
            courierInfo: {
                courierAccounts: []
            },
            loadingTable: false,
            isValid: false,
            btnSubscriptionPlan: {
                isSubmit: true,
                isCancel: true,
                isValid: false
            }
        }
    },
    watch: {
        'detail.dialog' (val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.dialogCustomerBase.$refs['userEdit'].clearValidate()
                })
                this.freshUser()
            } else {
                this.activeName = '0'
                this.detail.data = {}
                this.courierInfo.courierAccounts = []
                let validateInfo = this.validateInfo()
                if (!validateInfo) {
                    this.activeName = '0'
                    this.$nextTick(() => {
                        this.$refs.dialogCustomerBase.$refs['userEdit'].clearValidate()
                    })
                }
                this.statusBlock = false
                this.btnSubscriptionPlan = {
                    isSubmit: true,
                    isCancel: true,
                    isValid: false
                }
            }
        }
    },
    async created () {
        await this.freshUser()
    },
    computed: {
        currentTabComponent: {
            get: function () {
                return this.MenuList[this.activeName].componentName
            }
        }
    },
    methods: {
        freshUser () {
            let dataLog = {
                userId: this.detail.data.userId,
                email: this.detail.data.email,
                firstName: this.detail.data.firstName,
                lastName: this.detail.data.lastName,
                userCode: this.detail.data.userCode,
                address: this.detail.data.address,
                subDistrict: this.detail.data.subDistrict,
                district: this.detail.data.district,
                province: this.detail.data.province,
                zipcode: this.detail.data.zipcode,
                phoneNumber: this.detail.data.phoneNumber,
                isActivate: this.detail.data.isActivate,
                userStatus: this.detail.data.userStatus,
                saleCode: this.detail.data.saleCode,
                saleCodeSec: this.detail.data.saleCodeSec,
                isBlock: this.detail.data.isBlock,
                zohoInternalId: this.detail.data.zohoInternalId,
                deliveryCostType: this.detail.data.deliveryCostType,
                customerRetention: this.detail.data.customerRetention, // lable = customerRelation
                customerSupport: this.detail.data.customerSupport
            }
            this.detail.data.quotationDate ? this.quotationDate = this.$dayjs(this.detail.data.quotationDate).format('YYYY-MM-DD HH:mm:ss') : this.quotationDate = '-'
            this.log.payload.lhs.detail = { ...dataLog }
        },
        validateInfo () {
            let keyValidate = ['email', 'userCode', 'firstName', 'lastName', 'address', 'province', 'district', 'subDistrict', 'zipcode', 'phoneNumber']
            let valuedateCheck = true
            for (let e of keyValidate) {
                if (!this.detail.data[e]) {
                    valuedateCheck = false
                    break
                }
            }
            return valuedateCheck
        },
        validateInputConfirmSubmit (input) {
            if (input) {
                if (!input.trimEnd()) {
                    return 'กรุณากรอกสาเหตุที่ต้องแก้ไข'
                } else return true
            } else return 'กรุณากรอกสาเหตุที่ต้องแก้ไข'
        },
        submitEditUser () {
            this.isSubmitForm = true
            const validateInfo = this.validateInfo()
            if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.detail.data.email)) {
                this.$notify({
                    title: 'Warning',
                    message: 'กรุณาตรวจสอบอีเมล',
                    type: 'warning'
                })
                return false
            }
            // let zipcodeInvalid = false
            // if (this.$refs['dialogCustomerBase'].$refs['zipcode-system-component']) {
            //     this.$refs['dialogCustomerBase'].$refs['zipcode-system-component'].$v.$touch()
            //     zipcodeInvalid = (this.$refs['dialogCustomerBase'].$refs['zipcode-system-component'] && this.$refs['dialogCustomerBase'].$refs['zipcode-system-component'].$v.$invalid)
            // } **
            // || zipcodeInvalid **
            if (!validateInfo || !this.btnSubscriptionPlan.isSubmit) {
                this.$notify({
                    title: 'Warning',
                    message: 'กรุณาตรวจสอบข้อมูล',
                    type: 'warning'
                })

                // Subscription Module : If not submit btn
                if (!this.btnSubscriptionPlan.isSubmit) {
                    this.btnSubscriptionPlan.isValid = true
                    this.activeName = '4'
                }

                if (!validateInfo) {
                    this.activeName = '0'
                    this.$nextTick(() => {
                        this.$refs.dialogCustomerBase.$refs['userEdit'].validate()
                        // this.$refs['dialogCustomerBase'].$refs['zipcode-system-component'].$v.$touch() **
                    })
                }
            } else {
                this.$prompt('', 'สาเหตุที่ต้องแก้ไข', {
                    confirmButtonText: 'บันทึก',
                    cancelButtonText: 'ยกเลิก',
                    inputType: 'textarea',
                    inputValidator: this.validateInputConfirmSubmit
                }).then(async value => {
                    let param = {
                        userId: this.detail.data.userId,
                        email: this.detail.data.email,
                        firstName: this.detail.data.firstName,
                        lastName: this.detail.data.lastName,
                        userCode: this.detail.data.userCode,
                        address: this.detail.data.address,
                        subDistrict: this.detail.data.subDistrict,
                        district: this.detail.data.district,
                        province: this.detail.data.province,
                        zipcode: this.detail.data.zipcode,
                        phoneNumber: this.detail.data.phoneNumber,
                        isActivate: this.detail.data.isActivate,
                        userStatus: this.detail.data.userStatus,
                        saleCode: this.detail.data.saleCode,
                        saleCodeSec: this.detail.data.saleCodeSec,
                        isBlock: this.detail.data.isBlock,
                        zohoInternalId: this.detail.data.zohoInternalId,
                        deliveryCostType: this.detail.data.deliveryCostType,
                        customerRetention: this.detail.data.customerRetention, // lable = customerRelation
                        customerSupport: this.detail.data.customerSupport
                    }
                    if (this.detail.data.isBlock !== this.log.payload.lhs.detail.isBlock) {
                        param['isBlock'] = this.detail.data.isBlock
                    }
                    // set log detail
                    this.log.payload.rhs.detail = { ...param }

                    try {
                        this.$loading()
                        let resUserInfo = await fgApi.user.updateUserInfo(param)
                        if (resUserInfo.success) {
                            console.log('resUserInfo', resUserInfo)
                            // update courierAccount
                            let courierAccountsMapId = this.courierInfo.courierAccounts.map(e => { return e.courierAccountId })
                            let courierAccountsLog = this.courierInfo.courierAccounts.map(e => { return { apiData: e.apiData, courierAccountId: e.courierAccountId, courierId: e.courierId, name: e.name, timeEnd: e.timeEnd, timeStart: e.timeStart } })
                            var obj = {
                                target_user_id: this.detail.data.userId,
                                courier_accounts_id: courierAccountsMapId,
                                auto_courier: null
                            }
                            let courierAccounts = this.courierInfo.courierAccounts.map(e => {
                                let result = {
                                    courier_account_id: e.courierAccountId,
                                    courier_id: e.courierId,
                                    day: parseInt(e.day)
                                }
                                if (e.timeEnd) {
                                    result = { ...result, timeEnd: this.$dayjs(new Date(e.timeEnd)).format('HH:mm') }
                                }
                                if (e.timeStart) {
                                    result = { ...result, timeStart: this.$dayjs(new Date(e.timeStart)).format('HH:mm') }
                                }
                                if (e.timeEnd && e.timeStart) {
                                    result = { ...result, timeEnd: this.$dayjs(new Date(e.timeEnd)).format('HH:mm'), timeStart: this.$dayjs(new Date(e.timeStart)).format('HH:mm') }
                                }
                                return result
                            })
                            let courierAccountResult = { ...obj, auto_courier: courierAccounts }
                            let courierAccountResultLog = { ...obj, auto_courier: courierAccounts, courierAccounts: courierAccountsLog }
                            // set log courier
                            this.log.payload.rhs.courier = { ...courierAccountResultLog }
                            if (courierAccountResult.auto_courier.length !== 0) {
                                let resCourierAccount = await fgApi.courier.updateCourierAccount(courierAccountResult)
                                if (resUserInfo.success && resCourierAccount.success) {
                                    this.$message({
                                        message: 'บันทึกข้อมูลเรียบร้อย.',
                                        type: 'success'
                                    })
                                } else {
                                    this.$notify.error({
                                        title: 'Error',
                                        message: resCourierAccount.message
                                    })
                                }
                            }

                            // Update : Subscription Data
                            if (this.detail.data.subscriptionData !== null) {
                                try {
                                    let subscriptionParam = {
                                        subscription: {
                                            packageCode: this.detail.data.subscriptionData.subscription.packageCode,
                                            accountStatus: this.detail.data.subscriptionData.subscription.accountStatus,
                                            subscriptionDetail: {
                                                type: this.detail.data.subscriptionData.subscription.subscriptionDetail.type
                                            }
                                        },
                                        currentBillCycle: {
                                            ontopList: this.detail.data.subscriptionData.currentBillCycle.ontopList
                                        }
                                        // editor_email: this.$store.get('user/objUser').email,
                                        // editor_value: value.value
                                    }

                                    if (this.detail.data.subscriptionData.subscription.subscriptionDetail.type === 'A') {
                                        subscriptionParam.subscription.subscriptionDetail['cycle'] = this.detail.data.subscriptionData.subscription.subscriptionDetail.cycle
                                        subscriptionParam.subscription.subscriptionDetail['startDate'] = this.detail.data.subscriptionData.subscription.subscriptionDetail.startDate
                                        subscriptionParam.subscription.subscriptionDetail['endDate'] = this.detail.data.subscriptionData.subscription.subscriptionDetail.endDate
                                    }
                                    // await fgApi.subscription.putSubscription({ userId: this.detail.data.userId, param: subscriptionParam })
                                } catch (error) {
                                    console.error(error)

                                    this.$notify.error({
                                        title: 'Error',
                                        message: 'ไม่สามารถบันทึกข้อมูลของเมนู Subscription ได้'
                                    })
                                }
                            }
                        } else {
                            this.$notify.error({
                                title: 'Error',
                                message: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากอีเมล์นี้ถูกใช้แล้ว'
                            })
                        }
                        // update log
                        this.log.user_id = this.detail.data.userId
                        this.log.editor_email = this.$store.get('user/objUser').email
                        this.log.editor_value = value.value
                        this.log.timestamp = this.$dayjs().unix()
                        let resLog = await fgApi.log.setLogFinance(this.log)
                        console.log('update log ', resLog)
                        this.$emit('closeModalCustomer')
                        this.$emit('refreshUser')
                        this.dialogVisible = false
                        this.$loading().close()
                        this.detail.dialog = false
                    } catch (err) {
                        console.error(err)
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Input canceled'
                    })
                })
            }
        },
        onCancel () {
            this.detail.dialog = false
            this.isSubmitForm = false
            this.isCancel = true
        }
    }
}
</script>
<style lang="scss">
.labelForm {
    label {
        padding: unset !important;
    }
}
.dailogCustomerBase {
    .el-dialog__header {
        background-color: teal;
        color: white;
        button {
            font-size: large;
            i {
                color: #ffffff;
                &:hover {
                    color: white;
                }
            }
        }
    }
}
.my-autocomplete {
    li {
      line-height: normal;
      padding: 7px;

      .shipperCode {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .link {
        font-size: 12px;
        color: #b4b4b4;
      }
    }
  }
  .online-cancel-tag{
      margin:0 3px;
  }
</style>
<style scoped>
    .btn-customer-dialog{
        text-align: right;
        padding: 30px 0;
    }
</style>
